<script lang="ts">import { AsyncServerState, ServerState } from "./api/api";
import { AbTest, CatalogFilter, cfgApiBase, cfgAppName, cfgAppVersion, FeatureSet, getEndpoint, ReleaseStage, stateAbTest, stateCatalogFilter, stateFeatureSet, stateRealm, stateReleaseStage, stateTheme, Theme } from "@infinitro/config";
import { Dropdown } from "@infinitro/dropdown";
import { closeThisModal, ModalDialog, stateOpenModal, theme } from "@infinitro/global";
import { Modal } from "@infinitro/modal";
import { onMount } from "svelte";
export const thisModal = ModalDialog.DevSettings;
const closeModal = () => closeThisModal(thisModal);
function changeFeatures(value) {
	console.log("changeFeatures", value);
	stateFeatureSet.set(value);
	window.location.reload();
}
let serverState;
onMount(async () => {
	try {
		const result = await AsyncServerState({});
		serverState = result?.data?.health;
	} catch (e) {
		console.log(`api error ${e?.message ?? "unknown"}`);
	}
});
$: console.log(serverState);
</script>

{#if $stateOpenModal === ModalDialog.DevSettings}
	<Modal
		{closeModal}
		width="50vw"
		maxWidth="100vw"
		height="50vh"
		maxHeight="100vh"
		padding="20px 20px 20px 20px"
	>
		<h1>Developer Settings</h1>
		{cfgAppName()}
		{cfgAppVersion()}<br />
		{cfgApiBase()} [{serverState?.appVersion}] - {$stateRealm}<br />
		<p>
			<Dropdown
				size="small"
				options={[
					{ label: 'Preview', value: FeatureSet.Preview },
					{ label: 'Release', value: FeatureSet.Release }
				]}
				value={$stateFeatureSet}
				width="200px"
				onChange={changeFeatures}
			/>
		</p>
	</Modal>
{/if}

<style>
	h1 {
		margin: 0 0 20px 0;
		font-size: 16pt;
	}
	p {
		margin: 10px 0 10px 0;
	}
</style>
